export default {"src":"/_next/static/media/icone-helio.1b052f6c.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};